import React from 'react';
import MoreAboutUsConsts from "../json_config/more_about_us.json";

const MoreAboutUs = () => {
  return (
    <>
      <div className='moreaboutus pd-v-20'>
        <div className=''>
          {
            MoreAboutUsConsts.map((data) => {
              return (
                <div key={data.subTitle}>
                  <div className='title'>{data.subTitle}</div>
                  <div className='description'>{data.description}</div>
                </div>
              )
            })
          }
        <br />
        </div>
      </div>
    </>
  );
};

export default MoreAboutUs;
